import React, { PureComponent } from 'react';
import { SidePanelContext } from '../SidePanelAPI';
import PropTypes from 'prop-types';
import { st, classes } from './Header.st.css.js';
import { dataHooks } from '../constants';
import Heading from '../../Heading';
import Divider from '../../Divider';
import CloseButton from '../../CloseButton';
import Box from '../../Box';
import InfoIcon from '../../InfoIcon';
import Text from '../../Text';
import { TooltipCommonProps } from '../../common/PropTypes/TooltipCommon';
import { WixStyleReactContext } from '../../WixStyleReactProvider/context';
class Header extends PureComponent {
    renderStringTitle() {
        const { title, infoTooltipContent, infoTooltipProps } = this.props;
        return (React.createElement(Box, null,
            React.createElement(Heading, { size: "small", dataHook: dataHooks.sidePanelHeaderTitle }, title),
            infoTooltipContent && (React.createElement(Box, { marginLeft: "tiny" },
                React.createElement(InfoIcon, { dataHook: dataHooks.sidePanelHeaderTitleInfoIcon, content: infoTooltipContent, tooltipProps: infoTooltipProps })))));
    }
    renderSubtitle() {
        const { subtitle } = this.props;
        if (!subtitle)
            return null;
        const isStringSubtitle = typeof subtitle === 'string';
        if (!isStringSubtitle) {
            return subtitle;
        }
        return (React.createElement(Text, { skin: "standard", secondary: true, dataHook: dataHooks.sidePanelHeaderSubtitle }, subtitle));
    }
    renderTitle(onCloseButtonClick) {
        const { title } = this.props;
        const isStringTitle = typeof title === 'string';
        return (React.createElement("div", { className: st(classes.titleContainer, {
                noCloseButton: !onCloseButtonClick,
            }) },
            React.createElement("div", { className: classes.title },
                isStringTitle ? this.renderStringTitle() : title,
                this.renderSubtitle()),
            onCloseButtonClick && (React.createElement(CloseButton, { dataHook: dataHooks.sidePanelHeaderCloseButton, className: classes.closeButton, size: "large", onClick: onCloseButtonClick }))));
    }
    render() {
        const { children, showDivider, className } = this.props;
        return (React.createElement(SidePanelContext.Consumer, null, context => (React.createElement(WixStyleReactContext.Consumer, null, ({ newColorsBranding }) => (React.createElement("div", { className: st(classes.root, { newColorsBranding }, className), "data-hook": dataHooks.sidePanelHeader },
            this.renderTitle(context.onCloseButtonClick),
            children,
            showDivider && (React.createElement(Divider, { dataHook: dataHooks.sidePanelHeaderDivider }))))))));
    }
}
Header.displayName = 'SidePanel.Header';
Header.propTypes = {
    className: PropTypes.string,
    title: PropTypes.node,
    subtitle: PropTypes.node,
    infoTooltipContent: PropTypes.node,
    infoTooltipProps: PropTypes.shape(TooltipCommonProps),
    showDivider: PropTypes.bool,
    children: PropTypes.node,
};
Header.defaultProps = {
    showDivider: true,
};
export default Header;
//# sourceMappingURL=Header.js.map